import { Check, RotateCcw, SkipForward, Sparkles } from "lucide-react";
import type { Recommendation, WorkerState } from "../types";

export function TaskSheet({
  recommendation,
  worker,
  mode,
  approve,
  pass,
}: {
  recommendation: Recommendation | null;
  worker?: WorkerState;
  mode: "idle" | "offered" | "active";
  approve: () => void;
  pass: () => void;
}) {
  if (!recommendation || !worker) {
    return (
      <section className="quiet-prompt" aria-live="polite">
        <Sparkles size={18} />
        <div>
          <strong>Monitoring the whole kitchen</strong>
          <span>Double-press a worker band to open a personal action.</span>
        </div>
      </section>
    );
  }

  return (
    <section className={`task-sheet ${mode}`} aria-live="assertive">
      <div className="menu-visual">
        <img src={recommendation.targetImage} alt={`Finished ${recommendation.targetMenu}`} />
        <div>
          <span>Target menu</span>
          <strong>{recommendation.targetMenu}</strong>
        </div>
      </div>
      <div className="task-copy">
        <div className="task-kicker">
          <i style={{ background: worker.color }} />
          Worker {worker.id} · {worker.name}
        </div>
        <h2>{recommendation.title}</h2>
        <p className="instruction">
          Pick up <strong>{recommendation.ingredients.join(" and ")}</strong>, use the{" "}
          <u>{recommendation.tool}</u>, then{" "}
          <mark>{recommendation.action}</mark>
        </p>
        <p className="reason">{recommendation.reason}</p>
        <div className="evidence-line">{recommendation.evidence}</div>
      </div>
      <div className="task-actions">
        {mode === "active" ? (
          <button className="primary-action approved" type="button">
            <Check size={20} />
            Task accepted
          </button>
        ) : (
          <>
            <button className="primary-action" onClick={approve} type="button">
              <Check size={20} />
              Single · Accept
            </button>
            <button className="secondary-action" onClick={pass} type="button">
              <SkipForward size={18} />
              Double · Pass
            </button>
          </>
        )}
      </div>
      {mode === "active" ? (
        <div className="active-route">
          <RotateCcw size={15} />
          Follow the 3D route. Completion is recorded at the station.
        </div>
      ) : null}
    </section>
  );
}
